import { School } from '../types';

export const mockSchools: School[] = [
  {
    id: '450e8400-e29b-41d4-a716-446655440000',
    name: 'Lincoln Elementary School',
    code: 'LES',
    address: '100 Lincoln Avenue',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62701',
    phone: '555-0100',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    name: 'Washington Middle School',
    code: 'WMS',
    address: '200 Washington Street',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62702',
    phone: '555-0200',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440002',
    name: 'Jefferson High School',
    code: 'JHS',
    address: '300 Jefferson Boulevard',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62703',
    phone: '555-0300',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
];

let schools = [...mockSchools];

export const getSchools = (): School[] => {
  return [...schools];
};

export const getActiveSchools = (): School[] => {
  return schools.filter(s => s.isActive);
};

export const getSchoolById = (id: string): School | undefined => {
  return schools.find(s => s.id === id);
};

export const addSchool = (school: Omit<School, 'id' | 'createdAt' | 'updatedAt'>): School => {
  const newSchool: School = {
    ...school,
    id: `school-${Date.now()}`,
    createdAt: new Date(),
    updatedAt: new Date(),
  };
  schools.push(newSchool);
  return newSchool;
};

export const updateSchool = (id: string, updates: Partial<Omit<School, 'id' | 'createdAt'>>): School | undefined => {
  const index = schools.findIndex(s => s.id === id);
  if (index === -1) return undefined;

  schools[index] = {
    ...schools[index],
    ...updates,
    updatedAt: new Date(),
  };
  return schools[index];
};

export const deleteSchool = (id: string): boolean => {
  const index = schools.findIndex(s => s.id === id);
  if (index === -1) return false;
  schools.splice(index, 1);
  return true;
};
